const hostRenderTask = new WeakMap<HTMLElement, number>();
let renderTaskCounter = 0;

/** Invalide les fetch/rendus plus anciens sur le même hôte. */
export function beginHostRenderTask(host: HTMLElement): number {
  const taskId = ++renderTaskCounter;
  hostRenderTask.set(host, taskId);
  return taskId;
}

export function isLatestHostRenderTask(host: HTMLElement, taskId: number): boolean {
  return hostRenderTask.get(host) === taskId;
}

/** Tests uniquement. */
export function clearHostRenderTask(host: HTMLElement): void {
  hostRenderTask.delete(host);
}
